import httpClient from "./httpClient";

const profileCandidateService = {
  updateConnectionInfo(data,param) {
    return httpClient.put( `/api/profil-candidat/connexion-info?isLogged=${param.isLogged}&source=${param.source}`, data);
	},
	deleteFormation(data) {
    return httpClient.post("/profil-candidat/deleteFormation", data);
  },
  getExperiences(data){
    return httpClient.post("/profil-candidat/get-experiences-adv", data);
  },
  getTraining(data){
    return httpClient.post("/profil-candidat/get-trainings-adv", data);
  },
  getTransportMode(data) {
    return httpClient.post("/profil-candidat/get-transport-modes-adv", data);
  },
  allocate(data) {
    return httpClient.post("/api/adv/account/allocate", data);
  }
  
};

export default profileCandidateService;
